import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconCircleLetterF } from "@tabler/icons-react";

// OP06

export const formats = [
  { key: "OP11", value: "OP11" },
  { key: "EB02", value: "EB02" },
  { key: "OP10", value: "OP10" },
  { key: "OP09", value: "OP09" },
  { key: "OP08", value: "OP08" },
  { key: "OP07", value: "OP07" },
  { key: "EB01", value: "EB01" },
  { key: "OP06", value: "OP06" },
  { key: "OP05", value: "OP05" },
  { key: "OP04", value: "OP04" },
  { key: "OP03", value: "OP03" },
  { key: "OP02", value: "OP02" },
  { key: "OP01", value: "OP01" },
  { key: "P", value: "P" },
  { key: "ST", value: "ST" },
];

export const marketFormats = [
  { key: "all", value: "All" },
  { key: "23496", value: "PRB01" },
  { key: "23462", value: "OP08" },
  { key: "23387", value: "OP07" },
  { key: "23333", value: "EB01" },
  { key: "23272", value: "OP06" },
  { key: "23213", value: "OP05" },
  { key: "23024", value: "OP04" },
  { key: "22890", value: "OP03" },
  { key: "17698", value: "OP02" },
  { key: "3188", value: "OP01" },
];

export default function FormatFilter({
  selected,
  setSelected,
  customData,
  disallowEmptySelection = false,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  customData?: Item[];
  disallowEmptySelection?: boolean;
}) {
  let data: Item[] = [];
  if (customData) {
    data = customData;
  } else {
    data.push({ key: "all", value: "All" });
    data.push({ key: "23272", value: "OP06" });
    data.push({ key: "23213", value: "OP05" });
    data.push({ key: "23024", value: "OP04" });
    data.push({ key: "22890", value: "OP03" });
    data.push({ key: "17698", value: "OP02" });
    data.push({ key: "3188", value: "OP01" });
  }

  return (
    <GenericFilter
      classNames={"w-[120px]"}
      selected={selected}
      setSelected={setSelected}
      startContent={<IconCircleLetterF height={30} width={30} />}
      label="Format"
      selectionMode="single"
      data={data}
      disallowEmptySelection={disallowEmptySelection}
    />
  );
}
